import { useCallback, useMemo, useState } from "react";

const WORKSPACE_CRUMB = { label: "Workspace", href: "/v2/workspace" };

const buildItems = ({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }) => {
  const items = [WORKSPACE_CRUMB];

  if (pageLabel) {
    items.push({
      label: pageLabel,
      ...(pageHref ? { href: pageHref } : {}),
    });
  }

  if (subLabel) {
    items.push({
      label: subLabel,
      ...(subHref ? { href: subHref } : {}),
    });
  }

  if (tabLabel) {
    items.push({
      label: tabLabel,
      ...(tabHref ? { href: tabHref } : {}),
    });
  }

  return items;
};

export const useWorkspaceBreadcrumbs = () => {
  const [items, setItems] = useState([WORKSPACE_CRUMB]);

  const addItem = useCallback((item) => {
    if (!item || !item.label) return;

    setItems((prev) => [...prev, item]);
  }, []);

  const removeLastItem = useCallback(() => {
    setItems((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const clear = useCallback(() => {
    setItems([WORKSPACE_CRUMB]);
  }, []);

  const setPageBreadcrumb = useCallback((pageLabel, subLabel, options = {}) => {
    const { pageHref, subHref, tabLabel, tabHref } = options;
    setItems(buildItems({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }));
  }, []);

  const helpers = useMemo(
    () => ({
      setItems,
      addItem,
      removeLastItem,
      clear,
      setPageBreadcrumb,
    }),
    [addItem, removeLastItem, clear, setPageBreadcrumb]
  );

  return { items, helpers };
};

